export const ERROR_MESSAGE = 'Bitte überprüfen Sie Ihre Eingabe';
export const CHAR_LIMITATION_ERROR = 'Pflichtfeld (2-40 Buchstaben, Bindestriche sind zulässig)';
export const CHAR_NUM_LIMITATION_ERROR =
  'Pflichtfeld (2-40 Buchstaben, Zahlen und Bindestriche sind zulässig)';
export const PLEASE_SELECT_ERROR_MESSAGE = 'Bitte auswählen';
export const PHONE_ERROR = 'Ohne Trennzeichen, bis zu 13 Zahlen';
export const SUBMIT_ERROR = 'Bitte prüfen Sie Ihre Angaben';
export const PARTNER_ERROR = 'Bitte wählen Sie mindestens einen Partner';
export const REGEX_LATIN_ALPHABET =
  /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/;
export const REGEX_EMAIL =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const REGEX_PHONE = /^\+?[0-9\ ]{0,13}$/;
export const REGEX_STREET =
  /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð0-9 ,.'-]+$/;
export const REGEX_HOUSENR = /^([A-Za-z0-9])+$/;
export const REGEX_ZIPCODE = /([0-9]){5}/;
